import { render, staticRenderFns } from "./CaseReportBody.vue?vue&type=template&id=7c993bb5&"
import script from "./CaseReportBody.vue?vue&type=script&lang=js&"
export * from "./CaseReportBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports